// @ts-ignore
/* eslint-disable */
import { pwdEncrypt } from '@/utils/utils';
import { request } from '@umijs/max';

/** 获取当前的用户 POST /api/user/getMyUserInfo */
export async function currentUser(body?: any, options?: { [key: string]: any }) {
  return request<API.RESPONSE>('/api/user/getMyUserInfo', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/user/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/user/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  // 清空token
  localStorage.removeItem('token');
  return request<API.LoginResult>('/api/user/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改密码接口 POST /api/user/updateUserPassword */
export async function updateUserPassword(body: any, options?: { [key: string]: any }) {
  // 清空token
  localStorage.removeItem('token');
  return request<any>('/api/user/updateUserPassword', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "token": ''
    },
    data: body,
    ...(options || {}),
  });
}

/** 忘记密码-发送重置邮件 POST /api/user/forgotPassword */
export async function forgotPassword(body: { userAccount: string }, options?: { [key: string]: any }) {
  return request<any>('/api/user/public/forgetPasswordSendMail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
      tenantId:1
    },
    ...(options || {}),
  });
}

/** 忘记密码-获取账号  */
export async function forgotPwdGetAccount(body: { authCode: string }) {
  return request<any>('/api/user/public/getUserAccountByAuthCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
  });
}

/** 忘记密码-重置密码  */
export async function forgotPwdResetPwd(body: { authCode: string,password:string },userAccount:string) {
  return request<any>('/api/user/public/resetPasswordByAuthCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
      password:pwdEncrypt(userAccount,body.password)
    },
  });
}


/** 修改密码接口 POST /api/user/changePassword */
export async function changePassword(body: any, options?: { [key: string]: any }) {
  return request<any>('/api/user/changePassword', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}











